// extracted by mini-css-extract-plugin
module.exports = {"fixedRectangle":"index_fixedRectangle_3gKps","backgroundImage":"index_backgroundImage_29MJy"};